import { WIcon, WParagraph } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'

const ProviderDrawerError: FunctionComponent = () => {
  return (
    <div className='flex flex-col items-center justify-center h-full'>
      <WIcon
        icon='icWifiOff'
        size='xlarge'
        className='mb-4'
      />
      <WParagraph>Não foi possível carregar as informações</WParagraph>
    </div>
  )
}

export { ProviderDrawerError }
